import type { FC } from 'react';
import { cn } from '@components/lib/utils';
import Tooltip from '@components/Tooltip';

import type { FindingTier } from '../tiers';
import { TIER_ICON, TIER_ORDER, tierClasses } from '../tiers';

const TIER_TOOLTIP: Record<FindingTier, [singular: string, plural: string]> = {
  PRIORITY: ['Priority', 'Priorities'],
  IMPROVEMENT: ['Improvement', 'Improvements'],
  NOTE: ['Note', 'Notes'],
};

interface TierCountPillsProps {
  counts: Record<FindingTier, number>;
}

/** One segmented pill in the drawer header: how many suggestions per tier, the label on hover. */
export const TierCountPills: FC<TierCountPillsProps> = ({ counts }) => (
  <div
    className="inline-flex shrink-0 items-stretch divide-x divide-gray-200 rounded-md border border-gray-200 bg-white"
    data-testid="pbqa-summary"
  >
    {TIER_ORDER.map((tier) => {
      const Icon = TIER_ICON[tier];
      const count = counts[tier];
      const [singular, plural] = TIER_TOOLTIP[tier];
      return (
        <Tooltip key={tier} content={`${count} ${count === 1 ? singular : plural}`}>
          <span
            className={cn('flex cursor-default items-center gap-1 px-2 py-0.5 text-[13px]', tierClasses[tier].text)}
          >
            <Icon className="size-3.5" aria-hidden />
            <span className="font-semibold text-gray-900 tabular-nums" data-testid={`pbqa-summary-${tier}`}>
              {count}
            </span>
          </span>
        </Tooltip>
      );
    })}
  </div>
);
